export default __webpack_public_path__ + "static/housing-dining-bb5e13e2ab52af4f68a552cdacebe2fd.jpg";